<div class="position-relative">
  <div [class.form-disabled]="isLoading">
    <app-mon-entreprise-form
      label="Mon Entreprise"
      [initialValue]="company"
      [siret]="siret"
      (companyChanged)="onCompanyChanged($event)"
      (verifySiret)="onVerifySiret($event)"
      (disableNextButton)="onDisableNextButton($event)"
      [siretErrorMessage]="errorMessage"
      [siretErrorStatus]="errorStatus"
      (cleanSiretError)="onCleanSiretError()"
      (notificationClick)="onNotificationClick()"
    ></app-mon-entreprise-form>
  </div>

  <div *ngIf="isLoading" class="form-loading-overlay">
    <p-loader size="small"></p-loader>
  </div>
</div>
